// Lib
import React from 'react';
import { useTranslator } from '../../../components/i18n/useTranslator';

/**
 * This component is used when the element type does not have an appropriate modal component.
 */
const NoModalComponentElementModal = () => {
    const translate = useTranslator('modal', 'element.noModalComponent');

    return (
        <div className="NoModalComponentElementModal">
            <h2>{translate('title')}</h2>
            <div>
                <p>{translate('message')}</p>
            </div>
        </div>
    );
};

NoModalComponentElementModal.propTypes = {};

export default NoModalComponentElementModal;
